// constants/modeConfig.js

export const MODE_SPECIFIC_DATA = {
  referral: {
    items: [
      { id: 'solar', name: 'Solar Panels', icon: 'https://i.imgur.com/jxw6bHm.png', requiresForm: true },
      { id: 'battery', name: 'Battery Storage', icon: 'https://i.imgur.com/YXP6q5A.png', requiresForm: true },
      { id: 'roof', name: 'Roofing', icon: '🏠', requiresForm: true },
      { id: 'hvac', name: 'HVAC', icon: '❄️', requiresForm: false },
      { id: 'lighting', name: 'Permanent Lighting', icon: '💡', requiresForm: false },
      { id: 'windows', name: 'Windows', icon: '🪟', requiresForm: false },
      { id: 'ev-charger', name: 'EV Charger', icon: '⚡', requiresForm: true },
      { id: 'energy-audit', name: 'Energy Audit', icon: '📊', requiresForm: false, requiresBooking: true },
    ],
    itemLabel: 'Products of Interest',
    itemDescription: 'Select all that apply',
    apiEndpoint: '/api/referrals/submit', 
    updateEndpoint: '/api/referrals/customer-response',
  },
  
  onboarding: {
    items: [
      { id: '1099', name: '1099 Contractor', icon: '📋', requiresForm: true },
      { id: 'w2', name: 'W-2 Employee', icon: '📄', requiresForm: true },
    ],
    itemLabel: 'Employment Type',
    itemDescription: 'Select the employment classification',
    apiEndpoint: '/api/onboarding/submit', 
    updateEndpoint: '/api/onboarding/update',
  },
  
  install: {
    items: [
      { id: 'solar-install', name: 'Solar Installation', icon: '☀️', requiresForm: true },
      { id: 'battery-install', name: 'Battery Installation', icon: '🔋', requiresForm: true },
      { id: 'roof-install', name: 'Roof Installation', icon: '🏠', requiresForm: true },
      { id: 'ev-install', name: 'EV Charger Installation', icon: '⚡', requiresForm: true },
    ],
    itemLabel: 'Installation Type',
    itemDescription: 'Select the type of installation',
    apiEndpoint: '/api/install/submit',
    updateEndpoint: '/api/install/update',
  }
};

export const getItemsForMode = (mode) => {
  return MODE_SPECIFIC_DATA[mode] || MODE_SPECIFIC_DATA.referral;
};

const STATE_TIMEZONES = {
  'AL': 'America/Chicago', 'AK': 'America/Anchorage', 'AZ': 'America/Phoenix',
  'AR': 'America/Chicago', 'CA': 'America/Los_Angeles', 'CO': 'America/Denver',
  'CT': 'America/New_York', 'DE': 'America/New_York', 'FL': 'America/New_York',
  'GA': 'America/New_York', 'HI': 'Pacific/Honolulu', 'ID': 'America/Denver',
  'IL': 'America/Chicago', 'IN': 'America/New_York', 'IA': 'America/Chicago',
  'KS': 'America/Chicago', 'KY': 'America/New_York', 'LA': 'America/Chicago',
  'ME': 'America/New_York', 'MD': 'America/New_York', 'MA': 'America/New_York',
  'MI': 'America/New_York', 'MN': 'America/Chicago', 'MS': 'America/Chicago',
  'MO': 'America/Chicago', 'MT': 'America/Denver', 'NE': 'America/Chicago',
  'NV': 'America/Los_Angeles', 'NH': 'America/New_York', 'NJ': 'America/New_York',
  'NM': 'America/Denver', 'NY': 'America/New_York', 'NC': 'America/New_York',
  'ND': 'America/Chicago', 'OH': 'America/New_York', 'OK': 'America/Chicago',
  'OR': 'America/Los_Angeles', 'PA': 'America/New_York', 'RI': 'America/New_York',
  'SC': 'America/New_York', 'SD': 'America/Chicago', 'TN': 'America/Chicago',
  'TX': 'America/Chicago', 'UT': 'America/Denver', 'VT': 'America/New_York',
  'VA': 'America/New_York', 'WA': 'America/Los_Angeles', 'WV': 'America/New_York',
  'WI': 'America/Chicago', 'WY': 'America/Denver'
};
export function getTimezoneFromAddress(address) {
  const stateMatch = address.match(/\b([A-Z]{2})\b/);
  if (stateMatch) {
    const state = stateMatch[1];
    return STATE_TIMEZONES[state] || 'America/Denver'; 
  }
  return 'America/Denver'; 
}